var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPilRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 21,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#pil-right_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.976 20.602c5.522 0 10-4.477 10-10s-4.477-10-10-10h-15v20h15Z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 174,
  height: 77,
  x: -131.524,
  y: -18.898,
  stroke: "currentColor",
  rx: 19.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 879,
  height: 585.438,
  x: -595.5,
  y: -459.336,
  stroke: "currentColor",
  rx: 19.5
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF8D68",
  d: "M-3333-3670h5094v-100h-5094v100Zm5244 150V8788h100V-3520h-100ZM1761 8938h-5094v100h5094v-100Zm-5244-150V-3520h-100V8788h100Zm150 150c-82.84 0-150-67.16-150-150h-100c0 138.07 111.93 250 250 250v-100Zm5244-150c0 82.84-67.16 150-150 150v100c138.07 0 250-111.93 250-250h-100ZM1761-3670c82.84 0 150 67.16 150 150h100c0-138.07-111.93-250-250-250v100Zm-5094-100c-138.07 0-250 111.93-250 250h100c0-82.84 67.16-150 150-150v-100Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "pil-right_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-668-559.398H356v768H-668z"
})))));
export default SvgPilRight;